module.exports = __webpack_public_path__ + "img/sidebar-bg.png?94a75cb4756dec6ef91bdc50f9cf1d88";